import type {RootState} from '@/types/store/common';

export const selectAuth = (state: RootState) => state.authUser;



